export default __webpack_public_path__ + "static/media/Google Logo.c5462507.svg";